import { ParameterPropertyType } from 'src/types'
import { AutocompleteOption } from '@microservices/wiskey-react-components/dist/AutoComplete'

export type ReturnTransformCommonParameters = {
  numberOfWindows: AutocompleteOption | null
  timezone: AutocompleteOption | null
  pagination: AutocompleteOption | null
  ganttChart: AutocompleteOption | null
  view: AutocompleteOption | null
  appTitle: string
}

export const transformCommonParameters = (
  parameters: ParameterPropertyType[] | undefined
): ReturnTransformCommonParameters => {
  if (!parameters) {
    return {
      numberOfWindows: null,
      pagination: null,
      timezone: null,
      ganttChart: null,
      view: null,
      appTitle: '',
    }
  }

  const initialData: Record<string, unknown> = {}

  parameters.forEach(({ key, value }) => {
    if (key === 'appTitle') {
      initialData[key] = value

      return
    }
    initialData[key] = value ? { id: value?.toString(), label: value?.toString() } : null
  })

  return initialData as ReturnTransformCommonParameters
}
